import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeQuoteIgLook = 'quote-ig-panel' | 'quote-ig-sheet' | 'quote-ig-sheet-top';

const QUOTE_IG_LOOKS = new Set<string>(['quote-ig-panel', 'quote-ig-sheet', 'quote-ig-sheet-top']);
export const isWedgeQuoteIgLook = (look: string | undefined): look is WedgeQuoteIgLook => look !== undefined && QUOTE_IG_LOOKS.has(look);

/* Released Instagram contact row, an anchor to the native composer. The panel row (business contact panel) is a flex row with a 12px gap, 13px by 14px
   padding, a 44px floor, no underline and the inherited ink. The sheet row (decision maker sheet) is a flex row with an 11px gap and 12px by 14px
   padding, and takes a half pixel separator on top when a contact row sits above it (`quote-ig-sheet-top`), else no border. Both keep the declaration
   order of the source. The panel row is 62px tall at least and the sheet row 54px, so neither draws a transparent target or an anchor
   (wedgeSettingsDrawsHit): a region could only repeat the box, and the anchor is the rule a browser check found to move text raster elsewhere. */
export function wedgeQuoteIgStyle(look: WedgeQuoteIgLook): CSSProperties {
  const r = wedgeExactRole;
  switch (look) {
    case 'quote-ig-panel': return {
      display: 'flex', alignItems: 'center', gap: 12, padding: '13px 14px', minHeight: 44, textDecoration: 'none', color: 'inherit',
    };
    case 'quote-ig-sheet': return {
      display: 'flex', alignItems: 'center', gap: 11, padding: '12px 14px', textDecoration: 'none', color: 'inherit', borderTop: 'none',
    };
    case 'quote-ig-sheet-top': return {
      display: 'flex', alignItems: 'center', gap: 11, padding: '12px 14px', textDecoration: 'none', color: 'inherit', borderTop: `0.5px solid ${r('separator')}`,
    };
  }
}
